/* Apparelle — Delivery conditional · v2 (locale-aware ES + pt-PT) */
(function(){
  function isPT(){
    var l=((window.Shopify&&window.Shopify.locale)||document.documentElement.lang||'').toLowerCase();
    return l.indexOf('pt')===0;
  }
  function render(el){
    if(!el)return;
    if(isPT()){
      el.innerHTML='✓ Entrega em <strong>3 a 5 dias úteis</strong>';
      return;
    }
    try{
      var now=new Date();
      var hour=now.getHours();
      var day=now.getDay();
      var mAbbr=['Ene','Feb','Mar','Abr','May','Jun','Jul','Ago','Sep','Oct','Nov','Dic'];
      var addDays=function(d,n){var x=new Date(d);x.setDate(x.getDate()+n);return x;};
      var range=function(d1,d2){
        var sameMonth=d1.getMonth()===d2.getMonth();
        if(sameMonth)return d1.getDate()+'-'+d2.getDate()+' '+mAbbr[d1.getMonth()];
        return d1.getDate()+' '+mAbbr[d1.getMonth()]+'-'+d2.getDate()+' '+mAbbr[d2.getMonth()];
      };
      var msg='';
      if(day===0){
        msg='✓ Preparamos lunes · Recibe <strong>'+range(addDays(now,2),addDays(now,3))+'</strong>';
      }else if(day===6){
        msg='✓ Preparamos lunes · Recibe <strong>'+range(addDays(now,3),addDays(now,4))+'</strong>';
      }else if(hour<14){
        msg='✓ Antes de las <em>14h</em> · Recibe <strong>'+range(addDays(now,1),addDays(now,2))+'</strong>';
      }else{
        msg='✓ Preparamos mañana · Recibe <strong>'+range(addDays(now,2),addDays(now,3))+'</strong>';
      }
      el.innerHTML=msg;
    }catch(e){}
  }
  function init(){
    var els=document.querySelectorAll('[data-ap-deliv-text]');
    els.forEach(render);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);
  else init();
})();
